module.exports = __webpack_public_path__ + "static/media/footer.b436e1fc.jpg";